export default __webpack_public_path__ + "img/bJJYCLvU.5631c901.svg";